<ngx-loading
  class="full-screen-overlay"
  [show]="state$ | async"
  [config]="{ fullScreenBackdrop: true }"
></ngx-loading>
<app-toast-notification-internet-connectivity></app-toast-notification-internet-connectivity>
<router-outlet></router-outlet>
